import apiClient from './apiClient';

export interface J5N8PendingItem {
  form_id: 'pwj218f1' | 'pwj219f1' | 'pwj220f1' | 'pwj228f1';
  doc_no: string;
  development_no: string;
  entry_date: string;
  product_code: string;
  document_type: string;
  status: 'P';
}

export interface J5N8ReverseItem {
  form_id: J5N8PendingItem['form_id'];
  doc_no: string;
}

export interface J5N8PendingResponse {
  items: J5N8PendingItem[];
  total: number;
}

export interface J5N8ReverseResponse {
  results: Array<J5N8ReverseItem & { status: 'N' }>;
  count: number;
}

export const j5n8Api = {
  async pending(docStart: string, docEnd: string): Promise<J5N8PendingResponse> {
    const response = await apiClient.get('/api/j5n8/pending', {
      params: { doc_start: docStart, doc_end: docEnd },
    });
    return response.data;
  },

  async reverse(items: J5N8ReverseItem[]): Promise<J5N8ReverseResponse> {
    const response = await apiClient.post('/api/j5n8/reverse', { items, confirmed: true });
    return response.data;
  },
};
